import { render, staticRenderFns } from "./UpdateTrainer.vue?vue&type=template&id=76f822f4"
import script from "./UpdateTrainer.vue?vue&type=script&lang=js"
export * from "./UpdateTrainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports